import { useQuery, useQueryClient } from 'react-query';
import api from 'services';
import type { RevenueByMonthResponse } from 'services/requests';
import type { ApiError } from 'services/api.errors';
import { useQueryPage } from 'hooks/routes';
import { QueryKeys } from 'constants/queryKeys';
import type { AxiosError } from 'axios';

export const useGetEtzProfileRevenueByMonth = () => {
  const queryClient = useQueryClient();
  const { size, page } = useQueryPage();

  const params = {
    page,
    size,
  };

  const queryKey = [QueryKeys.etzProfileRevenueByMonth, page, size];

  const queryFn = async () => {
    const { data } = await api.getEtzProfileRevenueByMonth(params);
    return data;
  };

  return useQuery<RevenueByMonthResponse, AxiosError<ApiError>>(queryKey, queryFn, {
    initialData() {
      return queryClient.getQueryData<RevenueByMonthResponse>(queryKey);
    },
  });
};
